export default [
  {
    path: '/starred',
    component: () => import('./pages/starred.layout.vue'),
    children: [
      {
        path: 'project',
        name: 'starred-projects',
        component: () => import('./pages/page-starred-projects.vue')
      },
      {
        path: 'company',
        name: 'starred-companies',
        component: () => import('./pages/page-starred-companies.vue')
      },
      {
        path: 'wiki',
        name: 'starred-wikis',
        component: () => import('./pages/page-starred-wikis.vue')
      },
      {
        path: 'user',
        name: 'starred-users',
        component: () => import('./pages/page-starred-users.vue')
      },
      {
        path: 'team',
        name: 'starred-teams',
        component: () => import('./pages/page-starred-teams.vue')
      }
    ]
  }
];
